import styled from 'styled-components'

type Props = {
	isVisible: boolean
	hasFocus: boolean
}

export const Container = styled.div<Props>`
	background-color: ${({ theme }) => theme.color.input.error};
	height: ${({ isVisible }) => (isVisible ? '33px' : 0)};
	visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
	transition: height 135ms ease, box-shadow 135ms ease;
	width: 100%;
	border-radius: 4px;
	box-shadow: ${({ isVisible, hasFocus, theme }) => (isVisible && hasFocus ? `0 0 0 2px ${theme.color.input.error}` : 'none')};
	overflow: hidden;
	text-align: left;
`
